export const Colors = {
  PRIMARY: "#00CF5C",
  BACKGROUND: "#0E0E17",
  BACKGROUND_PRIMARY: "#141320",
  BACKGROUND_SECONDARY: "#171624",
  GREY: "#2D2B47",
  VIOLET: "#9996BF",
};
